import Image from "next/image";
import { FC } from "react";

type Props = {};

const Phone: FC<Props> = () => {
	return (
		<>
			<Image
				width={1600}
				height={1000}
				alt='iPhone'
				src='/images/iPhoneB.png'
				className='w-[702px] h-[515px] ml-[-100px] mr-[-13px] max-desktop:w-[370px] max-desktop:h-[282px] max-desktop:mr-[10px] max-desktop:mt-[55px] max-tablet:ml-[13px] max-tablet:mt-0'
			/>
			<></>
		</>
	);
};

export default Phone;
